import "./KeyFeatures.scss";

import AiImg from "../../assets/images/key-features/ai.png";
import GlobeImg from "../../assets/images/key-features/globe.png";
import CogsImg from "../../assets/images/key-features/cogs.png";
import ShieldImg from "../../assets/images/key-features/shield.png";
import NoCodeImg from "../../assets/images/key-features/no-code.png";

export default function KeyFeatures() {
	return (
		<>
			<div className="key-features">
				<div className="key-features-content-wrapper content-wrapper-lg">
					<div className="key-features-content">
						<h3 className="key-features-title" data-aos="fade-up">
							<span className="title-txt">Key Feutures</span>
						</h3>

						<p className="key-features-desc" data-aos="fade-up" data-aos-delay="100">
							The problem with traditional AI in Web3 is its
							reactive nature, requiring constant input. Vernus AI
							changes the game with proactive, self-learning AI
							agents that act autonomously, freeing you from
							repetitive tasks.
						</p>

						<div className="key-features-row">
							{/* card #1 */}
							<div className="key-features-col">
								<div className="key-feature-card" data-aos="zoom-in">
									<div className="cut-border" />

									<div className="key-feature-card-content">
										<div className="key-feature-img">
											<img
												src={AiImg}
												alt="AI"
												width={193}
												height={188}
											/>
										</div>

										<div className="key-feature-content">
											<h4 className="key-feature-title">
												Autonomous Ai Agents
											</h4>

											<p className="key-feature-desc">
												Go beyond simple assistance; our
												AI handles tasks independently.
											</p>
										</div>
									</div>
								</div>
							</div>

							{/* card #2 */}
							<div className="key-features-col">
								<div className="key-feature-card right-cut" data-aos="zoom-in">
									<div className="cut-border" />

									<div className="key-feature-card-content">
										<div className="key-feature-img">
											<img
												src={GlobeImg}
												alt="Globe"
												width={167}
												height={156}
											/>
										</div>

										<div className="key-feature-content">
											<h4 className="key-feature-title">
												Autonomous Ai Agents
											</h4>

											<p className="key-feature-desc">
												Go beyond simple assistance; our
												AI handles tasks independently.
											</p>
										</div>
									</div>
								</div>
							</div>

							{/* card #3 */}
							<div className="key-features-col">
								<div className="key-feature-card" data-aos="zoom-in">
									<div className="cut-border" />

									<div className="key-feature-card-content">
										<div className="key-feature-img">
											<img
												src={CogsImg}
												alt="Cogs"
												width={164}
												height={154}
											/>
										</div>

										<div className="key-feature-content">
											<h4 className="key-feature-title">
												Autonomous Ai Agents
											</h4>

											<p className="key-feature-desc">
												Go beyond simple assistance; our
												AI handles tasks independently.
											</p>
										</div>
									</div>
								</div>
							</div>

							{/* card #4 */}
							<div className="key-features-col">
								<div className="key-feature-card right-cut" data-aos="zoom-in">
									<div className="cut-border" />

									<div className="key-feature-card-content">
										<div className="key-feature-img">
											<img
												src={ShieldImg}
												alt="Shield"
												width={148}
												height={150}
											/>
										</div>

										<div className="key-feature-content">
											<h4 className="key-feature-title">
												Autonomous Ai Agents
											</h4>

											<p className="key-feature-desc">
												Go beyond simple assistance; our
												AI handles tasks independently.
											</p>
										</div>
									</div>
								</div>
							</div>

							{/* card #5 */}
							<div className="key-features-col">
								<div className="key-feature-card both-cut" data-aos="zoom-in">
									<div className="cut-border" />

									<div className="key-feature-card-content">
										<div className="key-feature-img">
											<img
												src={NoCodeImg}
												alt="No Code"
												width={234}
												height={234}
											/>
										</div>

										<div className="key-feature-content">
											<h4 className="key-feature-title">
												Autonomous Ai Agents
											</h4>

											<p className="key-feature-desc">
												Go beyond simple assistance; our
												AI handles tasks independently.
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
